"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _ReasonsModule = _interopRequireDefault(require("./Reasons.module.css"));

var _reactTextfit = require("react-textfit");

var _grommet = require("grommet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Reasons = /*#__PURE__*/function (_React$Component) {
  _inherits(Reasons, _React$Component);

  var _super = _createSuper(Reasons);

  function Reasons() {
    _classCallCheck(this, Reasons);

    return _super.apply(this, arguments);
  }

  _createClass(Reasons, [{
    key: "render",
    value: function render() {
      var _this = this;

      return /*#__PURE__*/_react["default"].createElement("div", {
        id: _ReasonsModule["default"].outer_div
      }, /*#__PURE__*/_react["default"].createElement("div", {
        id: _ReasonsModule["default"].text
      }, "Key Reasons To Join"), /*#__PURE__*/_react["default"].createElement(_grommet.Box, {
        id: _ReasonsModule["default"].quotes
      }, /*#__PURE__*/_react["default"].createElement(_grommet.Carousel, {
        controls: "arrows",
        fill: true
      }, this.props.reasons.map(function (mem, index) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          id: _ReasonsModule["default"].reasonContainer
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _ReasonsModule["default"].box
        }), /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            background: _this.props.color
          },
          id: _ReasonsModule["default"].img
        }, /*#__PURE__*/_react["default"].createElement("div", {
          id: _ReasonsModule["default"].number
        }, index + 1)), /*#__PURE__*/_react["default"].createElement("div", {
          id: _ReasonsModule["default"].number
        }, index + 1), /*#__PURE__*/_react["default"].createElement("div", {
          id: _ReasonsModule["default"].reason
        }, /*#__PURE__*/_react["default"].createElement(_reactTextfit.Textfit, {
          max: 15,
          mode: "multi",
          id: _ReasonsModule["default"].content,
          style: {
            height: "100%"
          }
        }, mem[0])), /*#__PURE__*/_react["default"].createElement("div", {
          id: _ReasonsModule["default"].reasonDes
        }, /*#__PURE__*/_react["default"].createElement(_reactTextfit.Textfit, {
          max: 11,
          mode: "multi",
          id: _ReasonsModule["default"].content,
          style: {
            height: "100%"
          }
        }, mem[1])));
      }))));
    }
  }]);

  return Reasons;
}(_react["default"].Component);

var _default = Reasons;
exports["default"] = _default;

//# sourceMappingURL=Reasons.js.map